import React, { FC } from 'react'
import LoginForm from '../../components/LoginForm'
import { Link } from 'react-router-dom'

const BookingLogin: FC = () => {
  return (
    <div className="login-wrap d-flex align-items-center flex-column justify-content-center flex-wrap h-100">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-12 order-2 order-lg-0">
            <LoginForm className="mb-2" />

            <p>
              No account yet?{' '}
              <Link to="/register" className="text-secondary">
                Sign up
              </Link>
            </p>
          </div>
          {/*<div className="col-12 order-1 mb-3 mt-3">*/}
          {/*  <span className="h6 d-block text-center">OR</span>*/}
          {/*</div>*/}
          {/*<div className="col-12 order-0 order-lg-2 mt-4 mt-lg-0">*/}
          {/*  <SocialLogins />*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  )
}

export default BookingLogin
